import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../auth/services';
import { SealedTenderService } from '../../services/sealed-tender/sealed-tender.service';

@Component({
  selector: 'app-sealed-tender-redirect',
  template: `
    <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
      <div class="text-center">
        <div class="spinner-border text-primary mb-3" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h5 class="text-muted">Redirecting to appropriate page...</h5>
        <p class="text-muted small">Please wait while we determine the best view for your tender type.</p>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SealedTenderRedirectComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private sealedTenderService: SealedTenderService
  ) {}

  ngOnInit(): void {
    const tenderId = this.route.parent?.snapshot.params['id'];
    const company = this.authService.getCurrentCompany();

    if (!tenderId || !company) {
      // Fallback to default behavior
      this.router.navigate(['locations'], { relativeTo: this.route.parent });
      return;
    }

    // Check if this is a sealed tender
    try {
      let isSealed = this.sealedTenderService.isSealedTender(company);

      // TEMPORARY FIX: Check if company is AACO (known sealed tender company)
      // This addresses the issue where company settings are not properly synchronized
      if (!isSealed && company?.name === 'AACO') {
        isSealed = true;
      }

      if (isSealed) {
        // For sealed tenders, redirect to suppliers page
        this.router.navigate(['suppliers'], { relativeTo: this.route.parent });
      } else {
        // For realtime tenders, redirect to locations page (default behavior)
        this.router.navigate(['locations'], { relativeTo: this.route.parent });
      }
    } catch (error) {
      // Fallback to locations page on error
      this.router.navigate(['locations'], { relativeTo: this.route.parent });
    }
  }
}
